import { render, staticRenderFns } from "./QuickView.vue?vue&type=template&id=09a63f4c&scoped=true&"
import script from "./QuickView.vue?vue&type=script&lang=js&"
export * from "./QuickView.vue?vue&type=script&lang=js&"
import style0 from "./QuickView.vue?vue&type=style&index=0&id=09a63f4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a63f4c",
  null
  
)

export default component.exports